import fetch from '../../../utils/fetch';
import {CONTACT_FORM_RESET} from './mutation-types';
import {CONTACT_FORM} from "../../../constants/api-routes";

const getDefaultState = () => {
    return {}
};
const state = getDefaultState();

function reset() {
    return {type: CONTACT_FORM_RESET}
}

const getters = {};

const actions = {
    submitForm({commit}, data) {
        return fetch(CONTACT_FORM, {method: 'POST', data: data});
    },
    reset({commit}) {
        commit(reset());
    }
};

const mutations = {
    [CONTACT_FORM_RESET](state) {
        Object.assign(state, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app/contact-form.js